<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-04-04 08:59:30
 * @LastEditTime: 2019-04-04 09:42:23
 -->
<template>
    <div id="app">
        <theHeader />
        <div class="main">
            <router-view></router-view>
        </div>
        <TheFotter v-show="show" />
    </div>
</template>
<script>
import TheHeader from "@/components/index/TheHeader";
import TheFotter from "@/components/index/TheFotter";
import { getUsers } from "@/api/login";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
    components: {
        TheHeader,
        TheFotter
    },
    name: "app",
    data() {
        return {
            show: false
        };
    },

    created() {
        setTimeout(() => {
            this.show = true;
        }, 300);
    },
    mounted() {
        function checkIE() {
            return (
                "-ms-scroll-limit" in document.documentElement.style &&
                "-ms-ime-align" in document.documentElement.style
            );
        }
        if (checkIE()) {
            window.addEventListener(
                "hashchange",
                () => {
                    var currentPath = window.location.hash.slice(1);
                    if (this.$route.path !== currentPath) {
                        this.$router.push(currentPath);
                    }
                },
                false
            );
        }
        const isIE = !!window.ActiveXObject || "ActiveXObject" in window;
        // debugger

        if (isIE) {
            let self = this;
            //debugger;
            let iframeEle = document.createElement("iframe");
            iframeEle.src =
                process.env.VUE_APP_CAS +
                "?service=" +
                process.env.VUE_APP_API +
                "/auth/queryUser";
            // debugger
            iframeEle.style.width = "0px";
            iframeEle.style.height = "0px";
            iframeEle.onload = function() {
                // next();
                getUsers().then(res => {
                    debugger;
                    if (res) {
                        let obj = res;
                        // 请求成功后cookies设置userInfoView
                        window.sessionStorage.setItem(
                            "userInfoView",
                            JSON.stringify(obj)
                        );
                        window.sessionStorage.setItem("userId", obj.userId);
                        self.$store.dispatch(
                            "changeUserPhone",
                            obj.phoneNumber
                        );
                        self.$store.dispatch("changeUserMail", obj.email);
                        if (obj.userName) {
                            self.$store.dispatch(
                                "changeUserName",
                                obj.userName
                            );
                        } else {
                            self.$store.dispatch(
                                "changeUserName",
                                obj.phoneNumber
                            );
                        }
                    }

                    if (res.indexOf("<!DOCTYPE html>") !== -1) {
                        self.$store.dispatch("changeUserName", "");
                    }
                });
            };
            document.body.appendChild(iframeEle);
        } else {
            // 其他浏览器直接请求接口
            getUsers()
                .then(res => {
                    if (res) {
                        let obj = res;
                        // 请求成功后cookies设置userInfoView
                        window.sessionStorage.setItem(
                            "userInfoView",
                            JSON.stringify(obj)
                        );
                        window.sessionStorage.setItem("userId", obj.userId);
                        this.$store.dispatch("changeUserName", obj.userName);
                        this.$store.dispatch(
                            "changeUserPhone",
                            obj.phoneNumber
                        );
                        this.$store.dispatch("changeUserMail", obj.email);
                        this.$store.dispatch("changeUserId", obj.userId);

                        if (obj.userName) {
                            this.$store.dispatch(
                                "changeUserName",
                                obj.userName
                            );
                        }else if(obj.userName==obj.phoneNumber && obj.userName.length == 12){
                            let a1 = obj.phoneNumber.slice(0, 3);
                            let a2 = obj.phoneNumber.slice(-4);
                            let phone = `${a1}****${a2}`;
                            this.$store.dispatch("changeUserName", phone);
                        } else {
                            let a1 = obj.phoneNumber.slice(0, 3);
                            let a2 = obj.phoneNumber.slice(-4);
                            let phone = `${a1}****${a2}`;
                            this.$store.dispatch("changeUserName", phone);
                        }
                    }
                    if (res.indexOf("<!DOCTYPE html>") !== -1) {
                        this.$store.dispatch("changeUserName", "");
                    }
                })
                .catch(() => {});
        }
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
#app {
    height: 100%;
    .main {
        position: relative;
        min-height: calc(100% - 117px);
        background-color: #f5f6f7;
    }
}
</style>
